import { LazyLoadImage } from 'react-lazy-load-image-component';
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import ArrowButtonLink from './../../../shared/components/ArrowButtonLink';
import { makeStyles } from '@material-ui/core/styles';
import styled from 'styled-components';
import DynamicElement from 'shared/components/DynamicElement';
import {
    withStyles,
    withWidth,
    Button,
} from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import moment from 'moment';
import { useDispatch, useSelector } from "react-redux";

import APIRegistrationDrawer from './../../../shared/components/APIRegistrationDrawer';

const styles = (theme) => ({

});

const ScrollDownIndicator = styled((props) => <a {...props}><svg xmlns="http://www.w3.org/2000/svg" width="10.723" height="6.524" viewBox="0 0 10.723 6.524">
    <g>
        <path fill="none" stroke="#ffffff" d="M0 0l4.993 5.447L9.985 0" transform="translate(.369 -11.136) translate(0 11.474)" />
    </g>
</svg></a>)`
  position: absolute;
  z-index: 1;
  bottom: 26px;
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
  padding: 10px;

  transition-duration: 2s;
  opacity: 1;
`;

const BoxBgImage = styled(Box)`
    background-size: contain;
    position: relative;

    &::before {
        content: "";
        position: absolute;
        top: 0; left: 0;
        width: 100%; height: 100%;
        opacity: 0.9;
        background-image: linear-gradient(96deg, #24272b 23%, rgba(18, 20, 22, 0.8) 78%);
    }
`;

const HeadingTypography = styled(Typography)`
    height: 90px;
    font-family: MinionPro-Disp;
    font-size: 72px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.4;
    letter-spacing: normal;
    text-align: left;
    color: #ffffff;
    margin-top: 16px;
    margin-bottom: 32px;

    h3{
        margin: 0;
    }
`;

const ContentTypography = styled(Typography)`
    font-family: Lato;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.88;
    letter-spacing: normal;
    text-align: left;
    color: #b6b8bc;
    margin-bottom: 40px;
    max-width: 432px;
`;

const CallToActionsButtons = styled(Grid)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 432px;

    .MuiButton-containedSecondary{
        height: 33px;
        font-family: Lato;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.21;
        letter-spacing: normal;
        text-align: center;
        text-transform: none;
        margin-top: 22px;
        margin-right: 8px;
        margin-left: 8px;
        
        color: #b08f6e;
        background-color: #ffffff;
        border: solid 1px #b6b8bc;

        box-shadow: none;
        color: #ffffff !important;
        border: solid 1px #b08f6e;
        background-color: #b08f6e;

        width: 130px;
    }

    .MuiButton-containedSecondary:disabled{
        border: solid 1px #ccced3;
        background-color: #ccced3;
    }
`;

const useStyles = makeStyles((theme) => ({

}));

function APIAccessButton({openDrawer}){
    const authUser = useSelector((state) => state.auth.user);
    const isAPIRequested = authUser && authUser.requestApiAccess && !authUser.api_allow;
    const isAPIEnabled = authUser && authUser.api_allow;

    return <Tooltip title={!isAPIRequested ? '' : `API access has already been requested on ${moment(authUser.requestApiAccessDate).format('DD/MM/YYYY')}.`}>
        <span>
            <Button
                type="button"
                variant="contained"
                color="secondary"
                onClick={() => isAPIRequested ? undefined : openDrawer()}
                style={{width: 'auto'}}
            >
                <div style={{display: 'flex'}}>
                    <span>{isAPIEnabled ? 'Go to API Link' : 'Request Access'}</span>
                    {isAPIRequested && <span style={{marginLeft: 6}}> – <span style={{color: '#9B2C03'}}>Requested</span></span>}
                </div>
            </Button>
        </span>
    </Tooltip>;
}

function APISection(props) {
    const classes = useStyles();
    return (<Box id={props.id} position="relative" height="100vh">
        <DynamicElement id="5ff7a181abbee9b8a71decde" buttonStyle={{ top: 80 }}>
            {({ value }) => <BoxBgImage height="100%" style={{ background: `url(${value}) no-repeat center center` }} >

                <Grid
                    container
                    direction="row"
                    justify="flex-start"
                    alignItems="center"
                    style={{ height: '100%', position: 'relative' }}
                >

                    <Grid item xs={12}>
                        <Box pl={10}>
                            <HeadingTypography variant="h1">
                                <DynamicElement id="5ff7a2ffabbee9b8a71decdf">
                                    {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                                </DynamicElement>
                            </HeadingTypography>
                            <ContentTypography>
                                <DynamicElement id="5ff654ac2a34245c31b64df5">
                                    {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                                </DynamicElement>
                            </ContentTypography>
                            <Box>
                                <CallToActionsButtons>
                                    {props.readMorePath && <ArrowButtonLink to={props.readMorePath} label={'Read More'} />}

                                    <APIAccessButton openDrawer={() => props.openDrawer()} />                                    
                                </CallToActionsButtons>
                            </Box>


                            <div style={{
                                position: 'absolute',
                                bottom: -60,
                                right: 85,
                                zIndex: 1
                            }}>
                                <DynamicElement id="5ff7a029abbee9b8a71decdd">
                                    {({ value }) => <LazyLoadImage src={value} style={{ width: 196, height: 232 }} />}
                                </DynamicElement>
                            </div>
                        </Box>
                    </Grid>

                </Grid>

                {props.showScrollDownIndicator && <ScrollDownIndicator href={props.showScrollDownIndicator} />}
            </BoxBgImage>}
        </DynamicElement>

    </Box>);
}


const MobileWrapper = styled.div`
  width: 100%;
  padding: 50px;
  display: flex;
  flex-direction: column;

  .MainText{
    font-size: 55px;
    line-height: 1;
    padding-top: 0;
    text-align: center;
    margin: 0;
    height: auto;
    margin-top: 10px;
    margin-bottom: 10px;

    h4{
        margin: 0;
    }
  }

  .description{
    padding-top: 50px;
    font-size: 16px;
    line-height: 1.19;
    text-align: center;
    padding: 0;
    margin: 0;
    margin-bottom: 30px;
  }
`;

const textStyle = {
    fontFamily: 'Lato',
    fontSize: '13px',
    fontWeight: '500',
    fontStretch: 'normal',
    fontStyle: 'normal',
    letterSpacing: 'normal',
    color: '#6d7279',
};

const SectionWrapper = (props) => {
    const classes = useStyles();

    const [sideDrawerOpen, setsideDrawerOpen] = React.useState(false);

    const openDrawer = () => {
        setsideDrawerOpen(true)
    }

    const closeDrawer = () => {
        setsideDrawerOpen(false)
    }

    return (<>

        <APIRegistrationDrawer sideDrawerOpen={sideDrawerOpen} closeDrawer={() => closeDrawer()} openEmailDialog={props.openEmailDialog} pushMessageToSnackbar={props.pushMessageToSnackbar} history={props.history} openRegisterDialog={props.openRegisterDialog} />

        {props.width === 'xs'
            ? <DynamicElement id="5ff7a181abbee9b8a71decde" buttonStyle={{ top: 80 }}>
                {({ value }) => <BoxBgImage style={{ backgroundImage: `url(${value})`, backgroundRepeat: 'no-repeat' }} >
                    <MobileWrapper>
                        <div>
                            <HeadingTypography variant="h1" className="MainText">
                                <DynamicElement id="5ff7a2ffabbee9b8a71decdf">
                                    {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                                </DynamicElement>
                            </HeadingTypography>
                        </div>
                        <div>
                            <ContentTypography className="description">
                                <DynamicElement id="5ff654ac2a34245c31b64df5">
                                    {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                                </DynamicElement>
                            </ContentTypography>
                        </div>

                        <Box textAlign="center">
                            <CallToActionsButtons>
                                {props.readMorePath && <ArrowButtonLink to={props.readMorePath} label={'Read More'} />}

                                <APIAccessButton openDrawer={() => openDrawer()} />
                            </CallToActionsButtons>
                        </Box>

                    </MobileWrapper>
                </BoxBgImage>
                }
            </DynamicElement>
            : <APISection {...props} openDrawer={() => openDrawer()} />}
    </>);
}

export default React.memo(withWidth()(withStyles(styles, { withTheme: true })(SectionWrapper)));